import { Component, inject } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';

import { SnackBarSuccessInterFace } from '../snackbar/snackbar';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [MatIconModule, MatSnackBarLabel],
  templateUrl: `./snackbar-error.html`,
  styleUrls: ['./snackbar-error.css'],
})
export class SnackbarError {
  public snackBarVar: SnackBarSuccessInterFace = {
    message: 'Success',
  };
  registry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);
  data = inject(MAT_SNACK_BAR_DATA) as SnackBarSuccessInterFace;

  constructor() {
    if (this.data?.message) {
      this.snackBarVar.message = this.data.message;
    }

    // Pastikan path ke file .svg benar
    this.registry.addSvgIcon(
      'error',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icon/error.svg'),
    );
  }
}
